import React from "react";
import "./LandingPage.css";
import NavBar from "./components/NavBar";
import Timestamp from "./components/Timestamp";
import Bumpups from "./components/Bumpups";
import Footer from "./components/Footer";

export default function LandingPage() {
  return (
    <div className="landing-page">
      <header>
        <NavBar />
      </header>

      <main className="landing-page__content">
        <section className="section">
          <Timestamp />
        </section>
        <section className="section">
          <Bumpups />
        </section>
      </main>

      <footer className="section">
        <Footer />
      </footer>
    </div>
  );
}
